// find the keyValue of a specific key name of a set of keyValues
export const findKeyValue = (keyValues, name) => {
  const keyValue = keyValues.find(keyValue => keyValue.key.name === name)
  return keyValue? keyValue.value : null
}